// @ts-nocheck
/* eslint-disable */
export const docCheckIcon = {
    data: ``,
    name: 'doc-check' as const
};